/* ============================================
   THE DRAW — PAGE 1 — Interactions
   ============================================ */

(function () {

  /* ============================================
     PIECE DATA
     Stored as: outer silhouette path + native dimensions + the
     centres of its circular holes.

     The board is drawn as ONE inline SVG (see initGate). That is a
     deliberate rebuild: the previous CSS-Grid board depended on the
     container's width/height rules actually applying, and on the
     live site they were not — the board stretched far past its cap,
     rows sized themselves to their content, and the four empty ranks
     collapsed to nothing, which is why every piece appeared bunched
     at the top. An SVG with a fixed viewBox cannot be renegotiated
     by any surrounding CSS: 64 squares always exist and are always
     square, whatever the container does.

     Holes are drawn as explicit <circle> elements filled with the
     underlying square's colour, rather than relying on fill-rule
     evenodd subpaths. Same visual result, but it cannot silently
     fail on individual pieces — which is what was happening to some
     of the purple ones.

     All pieces share ONE scale factor (derived from MAX_H) so their
     relative sizes are true, but each is CENTRED individually in its
     own square rather than sharing a baseline — that is what stops
     the pawns sitting low in their cells.
     ============================================ */
  var MAX_H = 235.9505;

  var PIECE_PATHS = {
    tower: { d: "M 0.60000002,0.60000002 V 109.6 H 8.1 l 1.75,1.25 0.25,82.25 2.5,2 68.5,-0.25 1.75,-1.75 0.25,-82.25 1.75,-1.25 h 7.5 V 0.60000002 H 76.1 V 21.1 l -1.5,1.5 H 56.1 L 54.85,21.6 54.6,0.60000002 H 38.35 V 21.1 l -1,1.25 -19,0.25 -1.5,-1.5 V 0.60000002 Z", w: 92.9500, h: 195.7008, holes: [{"cx": 46.626, "cy": 63.657}] },
    king: { d: "M 2.3499982,234.6 108.6,234.85 l 2.75,-2.25 v -90 h -7.75 l -1.75,-1.75 V 57.349998 l -15.75,-0.25 -1.25,-1.5 0.25,-18.75 1,-1 h 20.75 l 0.25,-16.25 -21,-0.25 -1.25,-1.75 V 0.59999824 H 68.6 V 18.599998 l -1.75,1.5 -22.5,-0.25 -1,-1.25 V 0.59999824 H 27.099998 V 17.849998 l -1.25,1.5 -20.9999998,0.25 0.25,16.25 H 25.849998 l 1,1 0.25,18.75 -1.25,1.5 -15.75,0.25 V 140.85 L 8.5999982,142.6 H 0.59999824 v 90 z", w: 111.9500, h: 235.4505, holes: [{"cx": 44.803, "cy": 65.27}, {"cx": 67.48, "cy": 65.27}] },
    queen: { d: "m 109.6,235.1 1.75,-2 v -90 h -8 l -1.5,-1.75 V 57.849998 H 86.849997 l -2,-1.75 0.25,-18.75 1,-1 H 106.85 l 0.25,-16.25 -40.000003,-0.25 -1,-1 -0.25,-18.24999976 h -19.75 l -0.25,17.99999976 -1,1.25 -39.9999983,0.25 0.25,16.25 H 25.849999 l 1,1 0.25,18.75 -2,1.75 h -15 V 141.35 l -1.5000003,1.75 h -8 v 90 l 2.75,2.25 z", w: 111.9500, h: 235.9505, holes: [{"cx": 67.147, "cy": 66.064}, {"cx": 44.47, "cy": 66.064}] },
    bishopLeft: { d: "m 15.485214,0.8506397 -1.5,1.25 L 0.73521352,66.85064 H 32.735214 l 2.75,2 0.75,1.75 -17.75,100.75 -0.25,5.25 2.75,1.75 69.75,-0.25 1.5,-1.25 0.5,-2 v -90.25 l 1,-1 6.25,-0.25 1.999996,-2 V 2.8506397 l -2.749996,-2.25 z", w: 102.5852, h: 178.9513, holes: [{"cx": 77.005, "cy": 26.577}] },
    bishopRight: { d: "m 87.1,0.8506397 1.5,1.25 13.25,64.7500003 h -32 l -2.75,2 -0.75,1.75 17.75,100.75 0.25,5.25 -2.75,1.75 -69.75,-0.25 -1.5,-1.25 -0.5,-2 v -90.25 l -1,-1 -6.25,-0.25 -2,-2 V 2.8506397 l 2.75,-2.25 z", w: 102.5852, h: 178.9513, holes: [{"cx": 25.58, "cy": 26.577}] },
    knightLeft: { d: "m 95.100554,177.61464 1.25,-1.5 v -2.75 l -13,-62.75 1.5,-1.25 h 31.999996 l 2,-1.75 -0.5,-6.5 -17.75,-99.2499975 -1.499996,-1.25000005 -3.75,0.25 V 8.8646425 l -1,1 -92.2499998,0.4999995 -1.50000004,2.250001 0.50000004,163.999997 2.25,1.5 z", w: 119.4718, h: 178.7156, holes: [{"cx": 90.902, "cy": 46.352}] },
    knightRight: { d: "m 24.371283,177.61464 -1.25,-1.5 v -2.75 l 13,-62.75 -1.5,-1.25 H 2.6212832 l -2,-1.75 0.5,-6.5 17.7499998,-99.2499975 1.5,-1.25000005 3.75,0.25 V 8.8646425 l 1,1 92.249997,0.4999995 1.5,2.250001 -0.5,163.999997 -2.25,1.5 z", w: 119.4718, h: 178.7156, holes: [{"cx": 28.57, "cy": 46.352}] },
    pawnLeft: { d: "M 92.85181,0.85162777 V 83.601628 H 0.60180997 l 0.25,-83.00000023 z", w: 93.4518, h: 84.2016, holes: [{"cx": 81.574, "cy": 10.884}] },
    pawnRight: { d: "M 0.60000002,0.85162777 V 83.601628 H 92.85 L 92.6,0.60162777 Z", w: 93.4518, h: 84.2016, holes: [{"cx": 11.878, "cy": 10.884}] }
  };

  /* How much of a square the tallest piece occupies. */
  var PIECE_FIT = 0.86;
  /* Pawns are genuinely short, so at the shared scale they read very
     small. A modest boost applies to them only — safe now that hole
     size is independent of piece scale. */
  var PIECE_BOOST = { pawnLeft: 1.5, pawnRight: 1.5 };
  /* Hole radius in SQUARE units — identical on every piece by
     construction, regardless of that piece's scale. */
  var HOLE_R = 0.035;

  /* Puzzle arms. Each starts displaced OUTWARD along its own axis
     (left arm starts further left, top arm further up, etc.) so the
     motion to assemble is an obvious inward drag along that axis —
     matching the spec's "pieces follow the axes of the quadrants".
     Colours/stroke/fill-rule come from the source SVG unchanged. */
  var PUZZLE_VIEWBOX_RAW = { w: 453.20169, h: 451.32654 };

  /* The SVG viewBox is PADDED beyond the artwork bounds. Reason: a
     piece dragged outside the SVG's own box stops receiving pointer
     events, which is exactly why pieces previously became stuck once
     moved away from the centre. Padding keeps every reachable
     position inside the hit area. */
  var PUZZLE_PAD = 130;
  var PUZZLE_VIEWBOX = (-PUZZLE_PAD) + " " + (-PUZZLE_PAD) + " " +
    (PUZZLE_VIEWBOX_RAW.w + 2 * PUZZLE_PAD) + " " +
    (PUZZLE_VIEWBOX_RAW.h + 2 * PUZZLE_PAD);

  var PUZZLE_PATHS = [
    { d: "m 0.85050409,172.47577 -0.25,106.25 2.25000001,2.75 H 92.85051 v -7.75 l 1.75,-1.75 h 83.49999 l 0.25,-15.75 1.5,-1.25 18.75,0.25 1,1 v 20.75 l 16.25,0.25 0.25,-21 1.75,-1.25 h 17 v -16.25 h -18 l -1.5,-1.75 0.25,-22.5 1.25,-1 h 18 v -16.25 h -17.25 l -1.5,-1.25 -0.25,-21 -16.25,0.25 v 20.75 l -1,1 -18.75,0.25 -1.5,-1.25 -0.25,-15.75 H 94.60051 l -1.75,-1.5 v -8 H 2.8505041 Z M 166.7785,214.92877 a 3.402,3.402 0 1 0 6.803,0 3.402,3.402 0 1 0 -6.803,0 z m 0,22.677 a 3.402,3.402 0 1 0 6.803,0 3.402,3.402 0 1 0 -6.803,0 z", startDx: -115, startDy: 0 },
    { d: "m 452.35119,172.52394 -2,-1.75 h -90 v 8 l -1.75,1.5 h -83.5 v 15 l -1.75,2 -18.75,-0.25 -1,-1 v -20.75 l -16.25,-0.25 -0.25,40 -1,1 -18.25,0.25 v 19.75 l 18,0.25 1.25,1 0.25,40 16.25,-0.25 v -20.75 l 1,-1 18.75,-0.25 1.75,2 v 15 h 83.5 l 1.75,1.5 v 8 h 90 l 2.25,-2.75 z m -172.437,42.453 a 3.402,3.402 0 1 0 6.803,0 3.402,3.402 0 1 0 -6.803,0 z m 0,22.677 a 3.402,3.402 0 1 0 6.803,0 3.402,3.402 0 1 0 -6.803,0 z", startDx: 115, startDy: 0 },
    { d: "m 192.3505,0.85077251 -2,2.49999999 V 84.850773 l -1.5,1.25 h -7.75 V 195.10077 h 16.25 v -20.5 l 1.5,-1.5 h 18.5 l 1.25,1 0.25,21.25 16.25,-0.25 v -20.5 l 1,-1.25 19,-0.25 1.5,1.5 v 20.5 l 16,0.25 0.25,-109.249997 h -7.75 l -1.5,-1.25 -0.25,-82.2500005 -2.5,-1.99999999 z m 31.37,131.55299749 a 3.402,3.402 0 1 0 6.804,0 3.402,3.402 0 1 0 -6.804,0 z", startDx: 0, startDy: -115 },
    { d: "m 180.9755,256.22577 v 109 h 7.5 l 1.75,1.25 0.25,82.25001 2.5,2 68.5,-0.25 1.75,-1.75 0.25,-82.25001 1.75,-1.25 h 7.5 v -109 h -16.25 v 20.5 l -1.5,1.5 h -18.5 l -1.25,-1 -0.25,-21 h -16.25 v 20.5 l -1,1.25 -19,0.25 -1.5,-1.5 v -20.5 z m 42.624,63.057 a 3.402,3.402 0 1 0 6.804,0 3.402,3.402 0 1 0 -6.804,0 z", startDx: 0, startDy: 115 }
  ];

  /* Generous — spec calls for it to feel impossible to fail. */
  var SNAP_THRESHOLD = 55;

  /* ============================================
     CHESS BOARD
     0-indexed: file 0-7 = a-h, rank 0-7 = rank1-rank8.
     Visitor = "w" (ranks 0-1, acid green). Mirror = "b" (ranks 6-7,
     purple). Mirror reflects across the horizontal axis.
     ============================================ */
  function initialBoard() {
    var back = ["tower", "knightLeft", "bishopLeft", "queen", "king", "bishopRight", "knightRight", "tower"];
    var pawnRow = ["pawnLeft", "pawnLeft", "pawnLeft", "pawnLeft", "pawnRight", "pawnRight", "pawnRight", "pawnRight"];
    var board = [];
    for (var r = 0; r < 8; r++) board.push(new Array(8).fill(null));
    for (var f = 0; f < 8; f++) {
      board[0][f] = { type: back[f], color: "w" };
      board[1][f] = { type: pawnRow[f], color: "w" };
      board[6][f] = { type: pawnRow[f], color: "b" };
      board[7][f] = { type: back[f], color: "b" };
    }
    return board;
  }

  function inBounds(f, r) { return f >= 0 && f < 8 && r >= 0 && r < 8; }

  function pieceKind(type) {
    if (type === "tower") return "rook";
    if (type === "king") return "king";
    if (type === "queen") return "queen";
    if (type === "bishopLeft" || type === "bishopRight") return "bishop";
    if (type === "knightLeft" || type === "knightRight") return "knight";
    return "pawn";
  }

  function slideMoves(board, f, r, color, dirs) {
    var moves = [];
    dirs.forEach(function (d) {
      var nf = f + d[0], nr = r + d[1];
      while (inBounds(nf, nr)) {
        var occ = board[nr][nf];
        if (!occ) { moves.push([nf, nr]); }
        else { if (occ.color !== color) moves.push([nf, nr]); break; }
        nf += d[0]; nr += d[1];
      }
    });
    return moves;
  }

  /* Movement patterns only. No check detection, castling, en passant
     or promotion: this gate always ends after 3 visitor moves, never
     via a real chess end-state, so full legality would be scope well
     beyond what a decorative gate needs. */
  function legalMoves(board, f, r) {
    var piece = board[r][f];
    if (!piece) return [];
    var kind = pieceKind(piece.type);
    var color = piece.color;
    var moves = [];

    if (kind === "rook") return slideMoves(board, f, r, color, [[1,0],[-1,0],[0,1],[0,-1]]);
    if (kind === "bishop") return slideMoves(board, f, r, color, [[1,1],[1,-1],[-1,1],[-1,-1]]);
    if (kind === "queen") return slideMoves(board, f, r, color, [[1,0],[-1,0],[0,1],[0,-1],[1,1],[1,-1],[-1,1],[-1,-1]]);

    if (kind === "king") {
      [[1,0],[-1,0],[0,1],[0,-1],[1,1],[1,-1],[-1,1],[-1,-1]].forEach(function (d) {
        var nf = f + d[0], nr = r + d[1];
        if (inBounds(nf, nr) && (!board[nr][nf] || board[nr][nf].color !== color)) moves.push([nf, nr]);
      });
      return moves;
    }
    if (kind === "knight") {
      [[1,2],[2,1],[2,-1],[1,-2],[-1,-2],[-2,-1],[-2,1],[-1,2]].forEach(function (d) {
        var nf = f + d[0], nr = r + d[1];
        if (inBounds(nf, nr) && (!board[nr][nf] || board[nr][nf].color !== color)) moves.push([nf, nr]);
      });
      return moves;
    }
    var dir = color === "w" ? 1 : -1;
    var startRank = color === "w" ? 1 : 6;
    if (inBounds(f, r + dir) && !board[r + dir][f]) {
      moves.push([f, r + dir]);
      if (r === startRank && !board[r + 2 * dir][f]) moves.push([f, r + 2 * dir]);
    }
    [f - 1, f + 1].forEach(function (nf) {
      var nr = r + dir;
      if (inBounds(nf, nr) && board[nr][nf] && board[nr][nf].color !== color) moves.push([nf, nr]);
    });
    return moves;
  }

  function initGate() {
    var gate = document.getElementById("drawGate");
    if (!gate) return;

    var boardEl = document.getElementById("drawGateBoard");
    var statusEl = document.getElementById("drawGateStatus");
    var skipBtn = document.getElementById("drawGateSkip");
    var NS = "http://www.w3.org/2000/svg";

    var board = initialBoard();
    var selected = null;
    var visitorMoves = 0;
    var locked = false;

    var DARK = "#0e0e0e";
    var LIGHT = "#303030";

    /* One SVG, viewBox 0 0 8 8 — one unit per square. Square by
       construction; no dependency on container sizing. */
    var svg = document.createElementNS(NS, "svg");
    svg.setAttribute("viewBox", "0 0 8 8");
    svg.setAttribute("preserveAspectRatio", "xMidYMid meet");
    svg.setAttribute("class", "draw-board-svg");
    boardEl.appendChild(svg);

    var layerSquares = document.createElementNS(NS, "g");
    var layerMarks = document.createElementNS(NS, "g");
    var layerPieces = document.createElementNS(NS, "g");
    svg.appendChild(layerSquares);
    svg.appendChild(layerMarks);
    svg.appendChild(layerPieces);

    function squareColor(f, r) {
      return ((f + r) % 2 === 0) ? DARK : LIGHT;
    }

    /* 64 squares, built once. y is flipped so rank 0 sits at the
       BOTTOM of the board (visitor side) and rank 7 at the top. */
    for (var r = 0; r < 8; r++) {
      for (var f = 0; f < 8; f++) {
        (function (f, r) {
          var rect = document.createElementNS(NS, "rect");
          rect.setAttribute("x", f);
          rect.setAttribute("y", 7 - r);
          rect.setAttribute("width", 1);
          rect.setAttribute("height", 1);
          rect.setAttribute("fill", squareColor(f, r));
          rect.setAttribute("class", "draw-sq");
          rect.addEventListener("click", function () { onSquareClick(f, r); });
          layerSquares.appendChild(rect);
        })(f, r);
      }
    }

    function clear(layer) {
      while (layer.firstChild) layer.removeChild(layer.firstChild);
    }

    function drawPiece(piece, f, r) {
      var p = PIECE_PATHS[piece.type];
      var boost = PIECE_BOOST[piece.type] || 1;
      var s = (PIECE_FIT * boost) / MAX_H;      /* shared scale */
      var pw = p.w * s, ph = p.h * s;
      /* centre this piece's own box inside its square */
      var ox = f + (1 - pw) / 2;
      var oy = (7 - r) + (1 - ph) / 2;

      var g = document.createElementNS(NS, "g");
      g.setAttribute("transform", "translate(" + ox + "," + oy + ") scale(" + s + ")");
      g.setAttribute("class", "draw-piece " +
        (piece.color === "w" ? "draw-piece--visitor" : "draw-piece--mirror"));

      var path = document.createElementNS(NS, "path");
      path.setAttribute("d", p.d);
      path.setAttribute("class", "draw-piece-shape");
      path.setAttribute("vector-effect", "non-scaling-stroke");
      g.appendChild(path);
      layerPieces.appendChild(g);

      /* Holes: real circles, filled with the square's own colour, at
         a size fixed in board units so every piece matches exactly. */
      p.holes.forEach(function (h) {
        var c = document.createElementNS(NS, "circle");
        c.setAttribute("cx", ox + h.cx * s);
        c.setAttribute("cy", oy + h.cy * s);
        c.setAttribute("r", HOLE_R);
        c.setAttribute("fill", squareColor(f, r));
        c.setAttribute("pointer-events", "none");
        layerPieces.appendChild(c);
      });
    }

    function render() {
      clear(layerMarks);
      clear(layerPieces);

      if (selected) {
        var sel = document.createElementNS(NS, "rect");
        sel.setAttribute("x", selected[0]);
        sel.setAttribute("y", 7 - selected[1]);
        sel.setAttribute("width", 1);
        sel.setAttribute("height", 1);
        sel.setAttribute("class", "draw-sq-selected");
        layerMarks.appendChild(sel);

        legalMoves(board, selected[0], selected[1]).forEach(function (m) {
          var dot = document.createElementNS(NS, "circle");
          dot.setAttribute("cx", m[0] + 0.5);
          dot.setAttribute("cy", (7 - m[1]) + 0.5);
          dot.setAttribute("r", 0.12);
          dot.setAttribute("class", "draw-sq-legal");
          dot.addEventListener("click", function () { onSquareClick(m[0], m[1]); });
          layerMarks.appendChild(dot);
        });
      }

      for (var r = 0; r < 8; r++) {
        for (var f = 0; f < 8; f++) {
          if (board[r][f]) drawPiece(board[r][f], f, r);
        }
      }
    }

    function move(fromF, fromR, toF, toR) {
      board[toR][toF] = board[fromR][fromF];
      board[fromR][fromF] = null;
      var mFromR = 7 - fromR, mToR = 7 - toR;
      board[mToR][toF] = board[mFromR][fromF];
      board[mFromR][fromF] = null;

      visitorMoves++;
      selected = null;
      render();

      if (visitorMoves >= 3) {
        locked = true;
        setTimeout(function () {
          if (statusEl) {
            statusEl.textContent = (window.drawStrings && window.drawStrings.gateDraw) || "A DRAW.";
            statusEl.classList.add("draw-gate-status--visible");
          }
          setTimeout(dismissGate, 1400);
        }, 350);
      }
    }

    function onSquareClick(f, r) {
      if (locked) return;
      var piece = board[r][f];

      if (selected) {
        var isLegal = legalMoves(board, selected[0], selected[1]).some(function (m) {
          return m[0] === f && m[1] === r;
        });
        if (isLegal) { move(selected[0], selected[1], f, r); return; }
        if (piece && piece.color === "w") { selected = [f, r]; render(); return; }
        selected = null; render(); return;
      }
      if (piece && piece.color === "w") { selected = [f, r]; render(); }
    }

    render();

    function dismissGate() {
      gate.classList.add("draw-gate--dismissed");
      setTimeout(function () {
        gate.style.display = "none";
        document.body.classList.remove("the-draw-gate-active");
      }, 700);
    }

    if (skipBtn) {
      skipBtn.addEventListener("click", function (e) { e.preventDefault(); dismissGate(); });
    }
    document.body.classList.add("the-draw-gate-active");
  }

  /* ============================================
     PUZZLE
     The SVG overlays the whole quadrant area (not sitting beside it),
     so the assembled cross visually divides the text into 4 quadrants
     and the pieces sit IN FRONT of the text.
     ============================================ */
  function initPuzzle() {
    var wrap = document.getElementById("drawPuzzle");
    if (!wrap) return;

    var NS = "http://www.w3.org/2000/svg";
    var svg = document.createElementNS(NS, "svg");
    svg.setAttribute("viewBox", PUZZLE_VIEWBOX);
    svg.setAttribute("class", "draw-puzzle-svg");
    svg.setAttribute("preserveAspectRatio", "xMidYMid meet");

    var vbW = PUZZLE_VIEWBOX_RAW.w + 2 * PUZZLE_PAD;
    var vbH = PUZZLE_VIEWBOX_RAW.h + 2 * PUZZLE_PAD;

    /* Ghost outline at the true assembled position — this is the
       visual cue for where pieces belong, alongside the faint
       quadrant divider lines in CSS. Non-interactive. */
    var ghost = document.createElementNS(NS, "g");
    ghost.setAttribute("class", "draw-puzzle-ghost");
    PUZZLE_PATHS.forEach(function (p) {
      var g = document.createElementNS(NS, "path");
      g.setAttribute("d", p.d);
      g.setAttribute("fill", "none");
      g.setAttribute("stroke", "#C8FF00");
      g.setAttribute("stroke-width", "1.2");
      g.setAttribute("stroke-dasharray", "5 6");
      g.setAttribute("fill-rule", "evenodd");
      ghost.appendChild(g);
    });
    svg.appendChild(ghost);

    var pieces = [];
    var dragging = null;

    PUZZLE_PATHS.forEach(function (p) {
      var path = document.createElementNS(NS, "path");
      path.setAttribute("d", p.d);
      path.setAttribute("fill", "#44196E");
      path.setAttribute("stroke", "#C8FF00");
      path.setAttribute("stroke-width", "1.2");
      path.setAttribute("fill-rule", "evenodd");
      path.setAttribute("class", "draw-puzzle-piece");

      var st = { el: path, dx: p.startDx, dy: p.startDy, solved: false };
      apply(st);
      svg.appendChild(path);
      pieces.push(st);
      attachDrag(path, st);
    });

    wrap.appendChild(svg);

    function apply(st) {
      st.el.setAttribute("transform", "translate(" + st.dx + "," + st.dy + ")");
    }

    function toSvg(clientX, clientY) {
      var rect = svg.getBoundingClientRect();
      return {
        x: (clientX - rect.left) * (vbW / rect.width),
        y: (clientY - rect.top) * (vbH / rect.height)
      };
    }

    function attachDrag(el, st) {
      function start(cx, cy) {
        if (st.solved) return;
        var p = toSvg(cx, cy);
        dragging = { st: st, x: p.x, y: p.y, dx: st.dx, dy: st.dy };
        el.classList.add("is-dragging");
        /* raise above siblings while dragging */
        el.parentNode.appendChild(el);
      }
      function moveTo(cx, cy) {
        if (!dragging || dragging.st !== st) return;
        var p = toSvg(cx, cy);
        st.dx = dragging.dx + (p.x - dragging.x);
        st.dy = dragging.dy + (p.y - dragging.y);
        apply(st);
      }
      function end() {
        if (!dragging || dragging.st !== st) return;
        dragging = null;
        el.classList.remove("is-dragging");
        if (Math.sqrt(st.dx * st.dx + st.dy * st.dy) < SNAP_THRESHOLD) {
          st.dx = 0; st.dy = 0; st.solved = true;
          el.classList.add("is-solved");
          apply(st);
          checkComplete();
        }
      }

      el.addEventListener("mousedown", function (e) { e.preventDefault(); start(e.clientX, e.clientY); });
      window.addEventListener("mousemove", function (e) { moveTo(e.clientX, e.clientY); });
      window.addEventListener("mouseup", end);

      el.addEventListener("touchstart", function (e) {
        var t = e.touches[0]; start(t.clientX, t.clientY);
      }, { passive: true });
      window.addEventListener("touchmove", function (e) {
        if (!dragging || dragging.st !== st) return;
        var t = e.touches[0]; moveTo(t.clientX, t.clientY); e.preventDefault();
      }, { passive: false });
      window.addEventListener("touchend", end);
    }

    function checkComplete() {
      var done = pieces.filter(function (s) { return s.solved; }).length;
      if (done === pieces.length) {
        if (ghost) ghost.style.display = "none";
        var label = document.getElementById("drawPuzzleClosed");
        if (label) label.classList.add("draw-puzzle-closed--visible");
      }
    }
  }

  function initReveal() {
    var items = document.querySelectorAll("[data-draw-reveal]");
    if (!("IntersectionObserver" in window)) {
      items.forEach(function (i) { i.classList.add("draw-revealed"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("draw-revealed");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    items.forEach(function (i) { io.observe(i); });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.body.classList.add("the-draw-page");
    initGate();
    initPuzzle();
    initReveal();
  });

})();
